import React from 'react';
import { Divider, Flex, List, Spinner } from '@banhala/ui-kit';
import { useGoodsReviews } from '../../queries/useGoodsReviews';
import { ReviewCard } from './ReviewCard';

const ReviewListContent: React.FC = () => {
  const { data: goodsReviews } = useGoodsReviews();
  return (
    <List
      data={goodsReviews.reviews}
      scrollEnabled={false}
      renderItem={({ item }) => <ReviewCard review={item} />}
      ItemSeparatorComponent={() => <Divider size={'medium'} />}
    />
  );
};
export const ReviewList: React.FC = props => {
  return (
    <React.Suspense
      fallback={
        <Flex.Center height={300}>
          <Spinner size={24} />
        </Flex.Center>
      }
    >
      <ReviewListContent {...props} />
    </React.Suspense>
  );
};
